"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredFieldsPlugin = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const workflow_core_1 = require("@sierralabs/workflow-core");
const FieldPicker_1 = __importDefault(require("../../pickers/FieldPicker"));
const StyledFormHelperText = (0, styled_components_1.default)(core_1.FormHelperText) `
  padding-left: 8px;
`;
const RequiredFieldsConfigurator = props => {
    const { condition, taskTypeId, onChange } = props;
    if (!condition.params) {
        condition.params = {};
    }
    if (!Array.isArray(condition.params.requiredFields)) {
        condition.params.requiredFields = [];
    }
    return (react_1.default.createElement(core_1.Box, { mt: 2 },
        react_1.default.createElement(FieldPicker_1.default, { hideCustomFields: true, taskTypeId: taskTypeId, value: condition.params.requiredFields || [], onChange: fields => {
                condition.params.requiredFields = fields.map(field => field.value);
                onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
            } }),
        react_1.default.createElement(StyledFormHelperText, null, "Checked fields will be required for this transition.")));
};
const RequiredFieldsDisplay = () => {
    return react_1.default.createElement(react_1.default.Fragment, null, "Required Fields");
};
exports.RequiredFieldsPlugin = {
    type: 'require-fields',
    label: 'Required Fields',
    configurator: RequiredFieldsConfigurator,
    display: RequiredFieldsDisplay,
    validate: () => true,
    validateImport: () => {
        return {
            severity: 'warning',
            message: 'Fields may differ between entities.'
        };
    },
    guard: (state, params) => {
        console.log('guards: require-fields', state, params);
        return (0, workflow_core_1.RequiredFieldsGuard)(state.context.taskEntity, params);
    }
};
//# sourceMappingURL=RequiredFieldsPlugin.js.map